module.exports = __webpack_public_path__ + "static/media/imageOnlyCard.0e3522f4.svg";